// extracted by mini-css-extract-plugin
export default {"spotify_container":"Spotify_spotify_container__pdE-t"};